(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-hero-slideshow-slide]')];
        this.dots = [...this.querySelectorAll('[data-hero-slideshow-dot]')];
        this.stage = this.querySelector('.hero-slideshow__stage');
        this.viewport = this.querySelector('.hero-slideshow__viewport');
        this.pauseButton = this.querySelector('[data-hero-slideshow-pause]');
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('hero-slideshow__slide--selected')));
        this.position = this.index;
        this.target = this.index;
        this.velocity = 0;
        this.direction = 1;
        this.stopped = false;
        this.hovered = false;
        this.editorPaused = false;
        this.focused = false;
        this.suppressClick = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.classList.toggle('hero-slideshow--draggable', this.slides.length > 1);
        this.render();
        this.classList.add('hero-slideshow--ready');
        this.syncSelection();
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, { signal });
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.schedule();
        }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
        }, { signal });
        this.addEventListener('keydown', event => {
          if (/INPUT|TEXTAREA|SELECT/.test(event.target.tagName) || event.target.isContentEditable || this.slides.length < 2) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          const step = event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
          if (!step && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          this.stop();
          if (step) this.select(this.index + step, false, step);
          else this.select(event.key === 'Home' ? 0 : this.slides.length - 1);
        }, { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.stop(); this.select(index); }, { signal }));
        this.pauseButton?.addEventListener('click', () => {
          this.stopped = !this.stopped;
          this.schedule();
        }, { signal });
        this.viewport.addEventListener('pointerdown', event => this.pointerDown(event), { signal });
        window.addEventListener('pointermove', event => this.pointerMove(event), { signal, passive: false });
        window.addEventListener('pointerup', event => this.pointerUp(event), { signal });
        window.addEventListener('pointercancel', event => this.pointerUp(event, true), { signal });
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); }
        }, { signal, capture: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => { this.finishMotion(); this.schedule(); }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId && !this.contains(event.target)) return;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId || slide === event.target || slide.contains(event.target));
          if (index < 0) return;
          this.editorPaused = true;
          this.select(index, !!event.detail?.load);
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId && !this.contains(event.target)) return;
          this.editorPaused = false;
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:section:unload', event => {
          if (String(event.detail?.sectionId) === this.dataset.sectionId || event.target.contains(this)) this.disconnectedCallback();
        }, { signal });
        this.schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.timer);
        clearTimeout(this.clickTimer);
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.drag = null;
        this.suppressClick = false;
        this.classList.remove('hero-slideshow--dragging');
      }
      normalize(index) { return (index % this.slides.length + this.slides.length) % this.slides.length; }
      select(index, instant = false, direction = 0, absolute = false) {
        if (!this.slides.length) return;
        const next = this.normalize(index);
        let distance = absolute ? index - this.target : next - this.normalize(this.target);
        const half = this.slides.length / 2;
        if (!absolute) {
          if (direction > 0 && distance <= 0) distance += this.slides.length;
          else if (direction < 0 && distance >= 0) distance -= this.slides.length;
          else if (!direction && distance > half) distance -= this.slides.length;
          else if (!direction && distance < -half) distance += this.slides.length;
        }
        this.direction = Math.sign(distance) || this.direction;
        this.target += distance;
        this.index = next;
        this.syncSelection();
        if (instant || this.reducedMotion.matches || this.dataset.effect === 'fade') this.finishMotion();
        else this.animate();
        this.schedule();
      }
      syncSelection() {
        this.slides.forEach((slide, index) => {
          const selected = index === this.index;
          slide.classList.toggle('hero-slideshow__slide--selected', selected);
          slide.setAttribute('aria-hidden', String(!selected));
          slide.inert = !selected;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      }
      render() {
        if (this.dataset.effect === 'fade') return;
        const count = this.slides.length;
        this.slides.forEach((slide, index) => {
          let offset = (index - this.position) % count;
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;
          if (Math.abs(offset) === count / 2) offset = Math.abs(offset) * this.direction;
          slide.style.transform = `translate3d(${offset * 100}%, 0, 0)`;
        });
      }
      animate() {
        if (this.frame) return;
        const tick = () => {
          if (!this.controller) return;
          if (this.drag?.active) this.velocity = this.drag.position - this.position;
          else this.velocity += (this.target - this.position) * .025;
          this.position += this.velocity;
          this.velocity *= .72;
          this.render();
          if (!this.drag?.active && Math.abs(this.target - this.position) < .0002 && Math.abs(this.velocity) < .0002) this.finishMotion();
          else this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      finishMotion() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.position = this.target;
        this.velocity = 0;
        this.render();
      }
      stop() { this.stopped = true; this.schedule(); }
      schedule() {
        clearTimeout(this.timer);
        const running = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.stopped && !this.hovered && !this.focused && !this.editorPaused && !document.hidden && !this.reducedMotion.matches;
        this.viewport.setAttribute('aria-live', running ? 'off' : 'polite');
        if (this.pauseButton) this.pauseButton.textContent = this.stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        if (running && this.controller) this.timer = setTimeout(() => this.select(this.index + 1, false, 1), Number(this.dataset.cycle) || 5000);
      }
      pointerDown(event) {
        if (this.slides.length < 2 || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.stop();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, origin: this.position, position: this.position, previousPosition: this.position, width: this.viewport.clientWidth, lastTime: 0, active: false, vertical: false };
      }
      pointerMove(event) {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId || drag.vertical) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { drag.vertical = true; this.animate(); return; }
          if (Math.abs(dx) < 12) return;
          drag.active = true;
          this.classList.add('hero-slideshow--dragging');
        }
        if (event.cancelable) event.preventDefault();
        drag.lastTime = performance.now();
        drag.previousPosition = drag.position;
        drag.position = drag.origin - (dx % (drag.width * this.slides.length)) / drag.width;
        this.direction = dx < 0 ? 1 : -1;
        this.animate();
      }
      pointerUp(event, cancelled = false) {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        this.drag = null;
        this.classList.remove('hero-slideshow--dragging');
        if (drag.active) {
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 350);
        }
        if (!cancelled && drag.active) {
          const restingPosition = this.position + this.velocity / .28;
          let next = Math.ceil(restingPosition - .5);
          if (next === this.target && performance.now() - drag.lastTime < 100) {
            const distance = drag.position - this.target;
            const delta = drag.position - drag.previousPosition;
            if (distance > 0 && delta > 0) next += 1;
            else if (distance < 0 && delta < 0) next -= 1;
          }
          this.select(next, false, 0, true);
        } else if (this.dataset.effect === 'fade') this.finishMotion();
        else this.animate();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
